import { ProductAdapter } from "@/core/models/product";
import { Api } from "@/core/services/api.service";
import { type ProductsList } from "@/apps/dashboard/catalog/core/infrastructure/service/productsService";
import { type ProductSearchFilterOptions } from "@/apps/dashboard/catalog/core/infrastructure/service/productFiltersService";

export const fetchProductsList = async (options: ProductSearchFilterOptions): Promise<ProductsList> => {
  const urlParams = prepareFetchProductsListParams(options);
  const response = await Api.new().get<ProductsListResponse>(`/products?${String(urlParams)}`, {
    headers: { accept: "application/ld+json" },
  });

  return {
    items: response.data["hydra:member"].map((productApi: ProductResponse) => ProductAdapter.adapt(productApi)),
    totalItems: response.data["hydra:totalItems"],
  };
};

const prepareFetchProductsListParams = (options: ProductSearchFilterOptions): URLSearchParams => {
  const min = options.price ? options.price.min : null;
  const max = options.price ? options.price.max : null;
  const field = options.sort ? options.sort.field : null;
  const order = options.sort ? options.sort.order : null;

  const urlParams = new URLSearchParams();
  Object.entries({
    search_product_buyback: options.label,
    categories: options.categories.length > 0 ? options.categories : null,
    status: options.status,
    "buybackPriceGradeA[gte]": min,
    "buybackPriceGradeA[lte]": max,
    [`order[${field}]`]: order,
    page: options.page,
    itemsPerPage: options.itemsPerPage,
  })
    .filter(([, value]) => !!value)
    .forEach(([key, value]) => {
      if (key === "categories" && Array.isArray(value)) {
        value.forEach((v) => urlParams.append("category[]", v));
        return;
      }

      urlParams.append(key, String(value));
    });

  return urlParams;
};

type ProductsListResponse = {
  "hydra:member": ProductResponse[];
  "hydra:totalItems": number;
};

type ProductResponse = {
  id: string;
  label: string;
  type: string;
  image: string;
  imageHd: string;
  eanCode: string;
  brand: string;
  status: string;
  comment: string;
  modele: string;
  reference: string;
  buybackPriceGradeA: number;
  buybackPriceGradeB: number;
  buybackPriceGradeC: number;
  buybackPriceGradeD: number;
  buybackPriceGradeE: number;
  buybackZeroNotAllowed: string;
  effectiveWeight: number;
  effectiveLength: number;
  effectiveWidth: number;
  effectiveHeight: number;
  weight: number;
  length: number;
  height: string;
  isCollectingIMEI: boolean;
  tacCodes: string[];
  category: object;
  secondaryCategories: object[];
};
